import { View, Text, Pressable } from "react-native";
import { memo, useEffect, useState } from "react";
import usePlatform from "@/utils/hooks/usePlatform";
import { StyleSheet } from "react-native-unistyles";
import SheetModal from "@/components/General/SheetModal";
import Unicon from "@/components/General/Unicon";

const PageTitle = ({title, subtitle, additionalContent}) => {
    const { isWeb } = usePlatform();
    const [sheetOpen, setSheetOpen] = useState(false);

    useEffect(() => {
        if(isWeb){
            document.title = `${title ? title + " | " : ""}${subtitle ? subtitle + " | " : ""}Reach`;
        }
    }, [title, subtitle])

    const titleContent = (
        <View style={styles.textContainer}>
            <View style={styles.titleRow}>
                <Text numberOfLines={1} style={styles.title(!!subtitle)}>{title}</Text>
                {additionalContent && (
                    <Unicon name="chevron-down" size={14} colorVariant="textSecondary" style={styles.chevron} />
                )}
            </View>
            {subtitle && <Text numberOfLines={1} style={styles.subtitle}>{subtitle}</Text>}
        </View>
    );

    if (!additionalContent) {
        return (
            <View style={styles.container}>
                {titleContent}
            </View>
        );
    }

    return (
        <>
            <Pressable onPress={() => setSheetOpen(true)} style={styles.container}>
                {titleContent}
            </Pressable>
            <SheetModal
                isOpen={sheetOpen}
                onCancel={() => setSheetOpen(false)}
                onClose={() => setSheetOpen(false)}
                title={title}
                subtitle={subtitle}
            >
                {typeof additionalContent === 'function'
                    ? additionalContent({ closeSheet: () => setSheetOpen(false) })
                    : additionalContent}
            </SheetModal>
        </>
    );
}

const styles = StyleSheet.create(({colors, fonts}, rt) => ({
    container: {
        zIndex:1,
        alignItems:rt.isPortrait ? "center" : "flex-start",
        justifyContent: "center",
        height: rt.isLandscape ? 43 : 40,
        ...(rt.isWeb ? { width: "100%" } : {}),
    },
    textContainer: {
        alignItems: rt.isPortrait ? "center" : "flex-start",
        justifyContent: "center",
    },
    titleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    chevron: {
        marginTop: 2,
    },
    title: (subtitle) => ({
        fontSize: subtitle ? (rt.isLandscape ? 20 : 15) : (rt.isLandscape ? 24 : 18),
        fontFamily: fonts.heading,
        color: colors.text,
        textAlign: rt.isPortrait ? "center" : "left",
    }),
    subtitle: {
        fontSize: 13,
        fontFamily: fonts.body,
        color: colors.textSecondary,
        textAlign: rt.isPortrait ? "center" : "left",
        marginTop: 2
    }
}))


export default memo(PageTitle);
